import { Navigate } from "react-router-dom";
import CommercialeVisiteModule from "../admin/CommercialeVisiteModule";
import { canOpenVisite, readVisiteSession } from "./VisiteLogin";

export default function VisiteHome() {
  const session = readVisiteSession();
  if (!session || !canOpenVisite(session)) return <Navigate to="/visite-login" replace />;
  return <CommercialeVisiteModule layout="app" />;
}
